const REF_RICH_TEXT_CONTEXT = Object.freeze({
    ANNOT_NEW: 'annot_new',
    ANNOT_EDIT: 'annot_edit',
    REPLY_NEW: 'reply_new',
});

const buildRichTextRef = ({ context, linkedid, linkedtype, cardId = null }) => {
    return cardId
        ? `ref_${context}_${linkedtype}_${linkedid}_card_${cardId}`
        : `ref_${context}_${linkedtype}_${linkedid}`;
};

export { REF_RICH_TEXT_CONTEXT, buildRichTextRef };
